import { openNewTab } from '../helpers';

export default function directionsWidget() {
  const widgetName = 'directionsWidget';
  const widgetOpts = directionsWidgetOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        customDirectionsWidget(data);
      } else {
        $widget.remove();
      }
    },
  });

  function customDirectionsWidget(widgetData) {
    const { Title, URL, ImageWithPath, ImageAlternateText } = widgetData.items[0];

    if (URL == null) {
      $widget.remove();
      $('body').addClass(`${widgetName}-no-data`);
    } else {
      $widget.find('.card-widget-item').replaceWith(
        `
        <img src="${ImageWithPath}" alt="${ImageAlternateText}" class="lozad">
        <a class="button" tabindex="0" href="${URL}" ${openNewTab(URL)}>${Title}</a>
        
        `,
      );
    }
  }
}
